import { PropsWithChildren } from 'react';

import { css } from '@compiled/react';

export const ContentStack = (props: PropsWithChildren) => {
	return <div css={contentStackCss}>{props.children}</div>;
};

const contentStackCss = css({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '24px',
	height: '100%',
	padding: '24px',
});
